import { default as affiliatevH9SxKbko3Meta } from "/opt/buildhome/repo/pages/admin/affiliate.vue?macro=true";
import { default as _91id_9381wAjSFTwKMeta } from "/opt/buildhome/repo/pages/admin/blog/edit/[id].vue?macro=true";
import { default as newG77munUzhwMeta } from "/opt/buildhome/repo/pages/admin/blog/new.vue?macro=true";
import { default as loginvBHthD8SMGMeta } from "/opt/buildhome/repo/pages/admin/login.vue?macro=true";
import { default as _91id_93f5C6OefrsZMeta } from "/opt/buildhome/repo/pages/blogs/[id].vue?macro=true";
import { default as indexXTNWI3ocnoMeta } from "/opt/buildhome/repo/pages/blogs/index.vue?macro=true";
import { default as hitungProductOM2hN8OItzMeta } from "/opt/buildhome/repo/pages/hitungProduct.vue?macro=true";
import { default as indexniDiYCWjuTMeta } from "/opt/buildhome/repo/pages/index.vue?macro=true";
import { default as kebijakanPrivasibzEkusZGDsMeta } from "/opt/buildhome/repo/pages/kebijakanPrivasi.vue?macro=true";
import { default as tentangKami2kAmzw6zDoMeta } from "/opt/buildhome/repo/pages/tentangKami.vue?macro=true";
export default [
  {
    name: affiliatevH9SxKbko3Meta?.name ?? "admin-affiliate",
    path: affiliatevH9SxKbko3Meta?.path ?? "/admin/affiliate",
    meta: affiliatevH9SxKbko3Meta || {},
    alias: affiliatevH9SxKbko3Meta?.alias || [],
    redirect: affiliatevH9SxKbko3Meta?.redirect,
    component: () => import("/opt/buildhome/repo/pages/admin/affiliate.vue").then(m => m.default || m)
  },
  {
    name: _91id_9381wAjSFTwKMeta?.name ?? "admin-blog-edit-id",
    path: _91id_9381wAjSFTwKMeta?.path ?? "/admin/blog/edit/:id()",
    meta: _91id_9381wAjSFTwKMeta || {},
    alias: _91id_9381wAjSFTwKMeta?.alias || [],
    redirect: _91id_9381wAjSFTwKMeta?.redirect,
    component: () => import("/opt/buildhome/repo/pages/admin/blog/edit/[id].vue").then(m => m.default || m)
  },
  {
    name: newG77munUzhwMeta?.name ?? "admin-blog-new",
    path: newG77munUzhwMeta?.path ?? "/admin/blog/new",
    meta: newG77munUzhwMeta || {},
    alias: newG77munUzhwMeta?.alias || [],
    redirect: newG77munUzhwMeta?.redirect,
    component: () => import("/opt/buildhome/repo/pages/admin/blog/new.vue").then(m => m.default || m)
  },
  {
    name: loginvBHthD8SMGMeta?.name ?? "admin-login",
    path: loginvBHthD8SMGMeta?.path ?? "/admin/login",
    meta: loginvBHthD8SMGMeta || {},
    alias: loginvBHthD8SMGMeta?.alias || [],
    redirect: loginvBHthD8SMGMeta?.redirect,
    component: () => import("/opt/buildhome/repo/pages/admin/login.vue").then(m => m.default || m)
  },
  {
    name: _91id_93f5C6OefrsZMeta?.name ?? "blogs-id",
    path: _91id_93f5C6OefrsZMeta?.path ?? "/blogs/:id()",
    meta: _91id_93f5C6OefrsZMeta || {},
    alias: _91id_93f5C6OefrsZMeta?.alias || [],
    redirect: _91id_93f5C6OefrsZMeta?.redirect,
    component: () => import("/opt/buildhome/repo/pages/blogs/[id].vue").then(m => m.default || m)
  },
  {
    name: indexXTNWI3ocnoMeta?.name ?? "blogs",
    path: indexXTNWI3ocnoMeta?.path ?? "/blogs",
    meta: indexXTNWI3ocnoMeta || {},
    alias: indexXTNWI3ocnoMeta?.alias || [],
    redirect: indexXTNWI3ocnoMeta?.redirect,
    component: () => import("/opt/buildhome/repo/pages/blogs/index.vue").then(m => m.default || m)
  },
  {
    name: hitungProductOM2hN8OItzMeta?.name ?? "hitungProduct",
    path: hitungProductOM2hN8OItzMeta?.path ?? "/hitungProduct",
    meta: hitungProductOM2hN8OItzMeta || {},
    alias: hitungProductOM2hN8OItzMeta?.alias || [],
    redirect: hitungProductOM2hN8OItzMeta?.redirect,
    component: () => import("/opt/buildhome/repo/pages/hitungProduct.vue").then(m => m.default || m)
  },
  {
    name: indexniDiYCWjuTMeta?.name ?? "index",
    path: indexniDiYCWjuTMeta?.path ?? "/",
    meta: indexniDiYCWjuTMeta || {},
    alias: indexniDiYCWjuTMeta?.alias || [],
    redirect: indexniDiYCWjuTMeta?.redirect,
    component: () => import("/opt/buildhome/repo/pages/index.vue").then(m => m.default || m)
  },
  {
    name: kebijakanPrivasibzEkusZGDsMeta?.name ?? "kebijakanPrivasi",
    path: kebijakanPrivasibzEkusZGDsMeta?.path ?? "/kebijakanPrivasi",
    meta: kebijakanPrivasibzEkusZGDsMeta || {},
    alias: kebijakanPrivasibzEkusZGDsMeta?.alias || [],
    redirect: kebijakanPrivasibzEkusZGDsMeta?.redirect,
    component: () => import("/opt/buildhome/repo/pages/kebijakanPrivasi.vue").then(m => m.default || m)
  },
  {
    name: tentangKami2kAmzw6zDoMeta?.name ?? "tentangKami",
    path: tentangKami2kAmzw6zDoMeta?.path ?? "/tentangKami",
    meta: tentangKami2kAmzw6zDoMeta || {},
    alias: tentangKami2kAmzw6zDoMeta?.alias || [],
    redirect: tentangKami2kAmzw6zDoMeta?.redirect,
    component: () => import("/opt/buildhome/repo/pages/tentangKami.vue").then(m => m.default || m)
  }
]